import { useEffect } from 'react';

/**
 * Calls the provided callback function on mount. Use this instead of an useEffect with empty dep. array
 *
 * @param {Function} callback Callback function to be called on mount
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDidMount = (callback: () => any): void => {
  useEffect(() => {
    if (typeof callback === 'function') {
      callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
